var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLockIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9168 10.5026V9.12801C17.9168 8.76345 17.7778 8.41382 17.5304 8.15604C17.2829 7.89826 16.9473 7.75344 16.5974 7.75344H3.40294C3.053 7.75344 2.7174 7.89826 2.46995 8.15604C2.22251 8.41382 2.0835 8.76345 2.0835 9.12801V17.3754C2.0835 17.74 2.22251 18.0896 2.46995 18.3474C2.7174 18.6052 3.053 18.75 3.40294 18.75H16.5974C16.9473 18.75 17.2829 18.6052 17.5304 18.3474C17.7778 18.0896 17.9168 17.74 17.9168 17.3754V16.0009V10.5026ZM6.04183 7.75344V5.37371C6.04183 4.28004 6.45887 3.23115 7.2012 2.45781C7.94353 1.68446 8.95035 1.25 10.0002 1.25C11.05 1.25 12.0568 1.68446 12.7991 2.45781C13.5415 3.23115 13.9585 4.28004 13.9585 5.37371V7.75344H6.04183Z",
    stroke: "#0e0333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6856 13.4007C11.6856 14.3084 10.9454 15.0485 10.0272 15.0485C9.10904 15.0485 8.3689 14.3084 8.3689 13.4007C8.3689 12.493 9.10904 11.7529 10.0272 11.7529C10.9454 11.7529 11.6856 12.493 11.6856 13.4007Z",
    stroke: "#0e0333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockIcon);
export default __webpack_public_path__ + "static/media/lock-icon.68e78aa97a49bfaef5f2ac9c45f2d997.svg";
export { ForwardRef as ReactComponent };